module.exports = __webpack_public_path__ + "media/images/utc_ccs_logo-19cc0aa91b69989bf6052e70a510f261.jpg";